import { useSelector } from 'react-redux';
import { selectFilterData } from '../../features/mainFilter/selectors';
import { getWizardV2State } from '../../features/wizard-v2/wizardService';
import translate from '../../utilities/translator';
import { getParamFromUrl, isEntryFlow } from '../../utilities/urlResolver';
import { useMemo } from 'react';
import abTesting from '../../services/abTesting';

const BEACH_IMAGES_COUNT = 9;
const CITY_IMAGES_COUNT = 2;

// This is hook that is used in WelcomeStep to show message based on entry flow and other logic.
const useGetWelcomeMessage = () => {
  const { searchEngine } = useSelector(selectFilterData);
  const { title, preselectionTitle, loadingImg, loadingImgAi } = getWizardV2State().welcomeStep;
  const efMessageId = getParamFromUrl('pr_messageId');
  const welcomeTitle = efMessageId ? preselectionTitle : title;

  let destinationId = getParamFromUrl('destinations') || getParamFromUrl('pr_destinations');
  // commented by Dror request
  // let destinationType = window.holidayFinder.beachDestinationIds?.includes(parseInt(destinationId)) ? 'beach' : 'city';
  let destinationType = 'beach'
  let destinationName = '';
  if (destinationId && destinationId.length) {
    destinationId = destinationId[0];
  }
  if (
    destinationId &&
    searchEngine?.where?.destinations?.length
  ) {
    destinationName = searchEngine.where.destinations.filter((destination) => destination.id === destinationId)[0]?.name || '';
  }
  let destinationGroupId = getParamFromUrl('destinationsGroups') || getParamFromUrl('pr_destinationsGroups');
  if (destinationGroupId && destinationGroupId.length) {
    destinationGroupId = destinationGroupId[0];
  }
  let destinationGroupName = '';
  if (
    destinationGroupId &&
    searchEngine?.where?.destinationsGroups?.length
  ) {
    destinationGroupName = searchEngine.where.destinationsGroups.filter(
      (destinationGroup) => destinationGroup.id === destinationGroupId
    )[0].name;
  }
  let whatId = getParamFromUrl('what') || getParamFromUrl('pr_what');
  if (whatId && whatId.length) {
    whatId = whatId[0];
  }
  let whatName = '';
  if (whatId && whatId !== -1 && searchEngine.what && searchEngine.what.length) {
    whatName = searchEngine.what.filter((whatTheme) => whatTheme.id === whatId)[0]?.value;
  }
  if (efMessageId) {
    if(destinationName || destinationGroupName || whatName){
      document.dispatchEvent(new CustomEvent('pr_welcome_message_parts_ready', {
        detail: {
          destinationName:destinationName,
          destinationGroupName:destinationGroupName,
          whatName:whatName
        }
      }));
    }
    // replace wizard custom title placeholders (outside of the react bundle)
    const wizardTitle = document.querySelector('.wizard-welcome-step__title2 b');
    if (wizardTitle && wizardTitle.innerText && (destinationName || destinationGroupName || whatName)) {
      const wizardTitleTxt = wizardTitle.innerText
        .replace('%destination%', destinationName)
        .replace('%destinationGroup%', destinationGroupName)
        .replace('%what%', whatName);
      wizardTitle.innerText = wizardTitleTxt;
    }
  }

  let maxNumber = destinationType === 'city' ? CITY_IMAGES_COUNT : BEACH_IMAGES_COUNT;
  const randomImageNumber = useMemo(() => Math.floor(Math.random() * maxNumber) + 1, [maxNumber]);

  let backgroundUrl = loadingImg || `https://d16tr0byigrcd.cloudfront.net/hf/images/welcome-screen/default_${destinationType}_${randomImageNumber}@2x.webp`;

  if (abTesting.aiAssistantV2 && loadingImgAi) {
    backgroundUrl = loadingImgAi;
  }

  if (isEntryFlow('link-presets-welcome') && getParamFromUrl('pr_backgroundImg')) {
    backgroundUrl = `https://image.content.travelyo-cdn.site/custom/holidayfinder/hp/hero/${getParamFromUrl('pr_backgroundImg')}`;
  }

  const entryFlowMessageText = translate(`entryFlow.welcomeBlock.message${efMessageId}`, {
    destination: destinationName,
    destinationGroup: destinationGroupName,
    what: whatName,
  });

  const subtitleText = efMessageId ? `${welcomeTitle ? `${welcomeTitle} ` : ''}${entryFlowMessageText}` : welcomeTitle;
  const subtitleShortText = efMessageId ? `${translate('entryFlow.welcomeBlock.letsFindYour')} ${entryFlowMessageText}` : welcomeTitle;

  return {
    welcomeTitle,
    entryFlowMessageText,
    subtitleText,
    subtitleShortText,
    backgroundUrl,
    efMessageId,
    isDestinationId: (destinationId || whatId || destinationGroupId),
    isDestination: (destinationName || whatName || destinationGroupName),
  }
}

export default useGetWelcomeMessage;
